import { draggableDriverFactory } from '../DragAndDrop/Draggable/Draggable.driver';
import { dataAttributes } from '../DragAndDrop/Draggable/constants';
import { dataHooks } from './constants';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const sortableListBaseFactory = ({ element }) => {
  deprecationTestkitLog(
    'sortableListBaseTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the SortableListBaseTestkit unidriver testkit instead.',
  );
  const draggableDriver = draggableDriverFactory({
    element: element.querySelector(`[data-hook="${dataHooks.provider}"]`),
  });

  return {
    /** checks if exists */
    exists: () => !!element,

    /** reorder sortable list items */
    reorder: ({ dataHookFrom, dataHookTo }) => {
      draggableDriver.beginDrag({
        dataHook: dataHookFrom,
      });
      draggableDriver.dragOver({ dataHook: dataHookTo });
      draggableDriver.endDrag();
    },

    /** get draggable item position */
    getItemPosition: ({ dataHook }) => {
      const draggableItems = [
        ...element.querySelectorAll(`[${dataAttributes.draggableTarget}]`),
      ];

      return draggableItems.findIndex(
        item =>
          item
            .querySelectorAll(`[${dataAttributes.draggableSource}]`)[0]
            .getAttribute('data-hook') === dataHook,
      );
    },
  };
};

export { sortableListBaseFactory };
